import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function ErrorCompletedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Evaluación ya completada</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Ya has completado esta evaluación. No es posible volver a realizarla con este enlace.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
